import { axios } from '@/utils/request'

const api = {
    clubList: '/adminapi/club/clubList',
    clubGradeList: '/adminapi/club/clubGradeList',
    clubDownloadUrl: '/adminapi/club/clubDownloadUrl',
    clubDetail: '/adminapi/club/clubDetail',
    editClub: '/adminapi/club/editClub',
    editClubGrade: '/adminapi/club/editClubGrade',
    deleteClub: '/adminapi/club/clubDelete',
    clubDeleteAll: '/adminapi/club/clubDeleteAll',
    setBaijiaAll: '/adminapi/club/setBaijiaAll',
    setShoupaiAll: '/adminapi/club/setShoupaiAll',
    setGradeAll: '/adminapi/club/setGradeAll',
    setSaiquAll: '/adminapi/club/setSaiquAll',
    getApplyOrderDetail: '/adminapi/club/applyOrderDetail',
    editApplyOrder: '/adminapi/club/editApplyOrder',
    getApplyUserDetail: '/adminapi/club/memberDetail',
    editApplyUser: '/adminapi/club/applyMemberEdit',
    refreshOrder: '/adminapi/club/refreshOrder',

    getGoodsList: '/adminapi/club/goodsList',
    deleteGoods: '/adminapi/club/goodsDelete',
    setGoodsRank: '/adminapi/club/setGoodsRank',
    setItemRank: '/adminapi/club/setItemRank',
    editGoods: '/adminapi/club/goodsEdit',
    addGoods: '/adminapi/club/goodsAdd',
    getGoodsDetail: '/adminapi/club/goodsDetail',
    getGoodsItemList: '/adminapi/club/itemList',
    addItem: '/adminapi/club/itemadd',
    editItem: '/adminapi/club/itemedit',
    deleteItem: '/adminapi/club/itemdelete',
    getItemDetail: '/adminapi/club/itemDetail',

    getJiansheOrderList: '/adminapi/club/jiansheOrderList',
    getJiansheDetail: '/adminapi/club/jiansheDetail',
    clubJiansheDetail: '/adminapi/club/clubJiansheDetail',
    editClubJianshe: '/adminapi/club/editClubJianshe',
    editJianshe: '/adminapi/club/editJianshe',

    deleteClubUser: '/adminapi/club/deleteClubUser',
    addClubUser: '/adminapi/club/addClubUser',
    getClubUserList: '/adminapi/club/clubUserList',
    scoreLogList: '/adminapi/club/scoreLogList',
    scoreEdit: '/adminapi/club/scoreEdit',


    getScoreApplyList: '/adminapi/club/scoreApplyList', 
    getScoreApplyDetail: '/adminapi/club/scoreApplyDetail', 
    scoreApplyDo: '/adminapi/club/scoreApplyDo', 
    clubGradeJiansheList: '/adminapi/club/clubGradeJiansheList', 
}

export default api

export function getClubList(parameter) {
  return axios({
    url: api.clubList,
    method: 'get',
    params: parameter
  })
}

export function getClubGradeList(parameter) {
  return axios({
    url: api.clubGradeList,
    method: 'get',
    params: parameter
  })
}

export function getClubDownloadUrl(parameter) {
    return axios({
        url: api.clubDownloadUrl,
        method: 'get',
        params: parameter
    })
}

export function getClubDetail(parameter) {
  return axios({
    url: api.clubDetail,
    method: 'get',
    params: parameter
  })
}
export function editClub(parameter) {
  return axios({
    url: api.editClub,
    method: 'post',
    data: parameter
  })
}
export function editClubGrade(parameter) {
  return axios({
    url: api.editClubGrade,
    method: 'post',
    data: parameter
  })
}

export function editClubGradeNote(parameter) {
    return axios({
      url: '/adminapi/club/editClubGradeNote',
      method: 'post',
      data: parameter
    })
  }

  export function refuseClubGrade(parameter) {
    return axios({
      url: '/adminapi/club/refuseClubGrade',
      method: 'post',
      data: parameter
    })
  }
  
export function deleteClub(parameter) {
    return axios({
        url: api.deleteClub,
        method: 'post',
        data: parameter
    })
}

export function clubDeleteAll(parameter) {
    return axios({
        url: api.clubDeleteAll,
        method: 'post',
        data: parameter
    })
}
export function setBaijiaAll(parameter) {
    return axios({
        url: api.setBaijiaAll,
        method: 'post',
        data: parameter
    })
}
export function setShoupaiAll(parameter) {
    return axios({
        url: api.setShoupaiAll,
        method: 'post',
        data: parameter
    })
}
export function setGradeAll(parameter) {
    return axios({
        url: api.setGradeAll,
        method: 'post',
        data: parameter
    })
}
export function setSaiquAll(parameter) {
    return axios({
        url: api.setSaiquAll,
        method: 'post',
        data: parameter
    })
}

export function getApplyOrderDetail(parameter) {
    return axios({
        url: api.getApplyOrderDetail,
        method: 'post',
        data: parameter
    })
}
export function editApplyOrder(parameter) {
    return axios({
        url: api.editApplyOrder,
        method: 'post',
        data: parameter
    })
}
export function refreshOrder(parameter) {
    return axios({
        url: api.refreshOrder,
        method: 'post',
        data: parameter
    })
}
export function getGoodsList(parameter) {
    return axios({
        url: api.getGoodsList,
        method: 'post',
        data: parameter
    })
}
export function deleteGoods(parameter) {
    return axios({
        url: api.deleteGoods,
        method: 'post',
        data: parameter
    })
}
export function setGoodsRank(parameter) {
    return axios({
        url: api.setGoodsRank,
        method: 'post',
        data: parameter
    })
}
export function setItemRank(parameter) {
    return axios({
        url: api.setItemRank,
        method: 'post',
        data: parameter
    })
}
export function editGoods(parameter) {
    return axios({
        url: api.editGoods,
        method: 'post',
        data: parameter
    })
}
export function addGoods(parameter) {
    return axios({
        url: api.addGoods,
        method: 'post',
        data: parameter
    })
}
export function getGoodsDetail(parameter) {
    return axios({
        url: api.getGoodsDetail,
        method: 'post',
        data: parameter
    })
}
export function getGoodsItemList(parameter) {
    return axios({
        url: api.getGoodsItemList,
        method: 'post',
        data: parameter
    })
}
export function addItem(parameter) {
    return axios({
        url: api.addItem,
        method: 'post',
        data: parameter
    })
}
export function editItem(parameter) {
    return axios({
        url: api.editItem,
        method: 'post',
        data: parameter
    })
}
export function deleteItem(parameter) {
    return axios({
        url: api.deleteItem,
        method: 'post',
        data: parameter
    })
}
export function getItemDetail(parameter) {
    return axios({
        url: api.getItemDetail,
        method: 'post',
        data: parameter
    })
}
export function getJiansheOrderList(parameter) {
    return axios({
        url: api.getJiansheOrderList,
        method: 'post',
        data: parameter
    })
}
export function getJiansheDetail(parameter) {
    return axios({
        url: api.getJiansheDetail,
        method: 'post',
        data: parameter
    })
}
export function editJianshe(parameter) {
    return axios({
        url: api.editJianshe,
        method: 'post',
        data: parameter
    })
}



export function deleteClubUser(parameter) {
    return axios({
        url: api.deleteClubUser,
        method: 'post',
        data: parameter
    })
}

export function addClubUser(parameter) {
    return axios({
        url: api.addClubUser,
        method: 'post',
        data: parameter
    })
}

export function getClubUserList(parameter) {
    return axios({
        url: api.getClubUserList,
        method: 'post',
        data: parameter
    })
}
export function scoreLogList(parameter) {
    return axios({
        url: api.scoreLogList,
        method: 'post',
        data: parameter
    })
}

export function scoreEdit(parameter) {
    return axios({
        url: api.scoreEdit,
        method: 'post',
        data: parameter
    })
}

export function getScoreApplyList(parameter) {
    return axios({
        url: api.getScoreApplyList,
        method: 'post',
        data: parameter
    })
}
export function getScoreApplyDetail(parameter) {
    return axios({
        url: api.getScoreApplyDetail,
        method: 'post',
        data: parameter
    })
}

export function scoreApplyDo(parameter) {
    return axios({
        url: api.scoreApplyDo,
        method: 'post',
        data: parameter
    })
}

export function clubGradeJiansheList(parameter) {
    return axios({
        url: api.clubGradeJiansheList,
        method: 'post',
        data: parameter
    })
}

export function editClubJianshe(parameter) {
    return axios({
        url: api.editClubJianshe,
        method: 'post',
        data: parameter
    })
}

export function clubJiansheDetail(parameter) {
    return axios({
        url: api.clubJiansheDetail,
        method: 'post',
        data: parameter
    })
}
